import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import PageContainer from './components/page_container';
import MainPage from './pages/main_page';
import { RootStoreContext } from './store/store_context';
import RootStore from './store/root_store';
import { ChakraProvider } from '@chakra-ui/react';
import LoginPage from './pages/login_page';
import ThemeEditPage from './pages/theme_edit_page';
import PrivateRoute from './pages/private_route';
import theme from './theme';

const router = createHashRouter([
  {
    path: '/',
    element: <LoginPage />,
  },
  {
    path: '/main',
    element: (
      <PrivateRoute>
        <MainPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/edit',
    element: (
      // <PrivateRoute>
        <ThemeEditPage />
      // </PrivateRoute>
    ),
  },
]);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <RootStoreContext.Provider value={new RootStore()}>
    <ChakraProvider theme={theme}>
      <PageContainer>
        <RouterProvider router={router} />
      </PageContainer>
    </ChakraProvider>
  </RootStoreContext.Provider>
);
